import type {ReactElement} from 'react';
import React from 'react';
import {AnimationType} from '@PosterWhiteboard/classes/item-animation.class';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {ColorFillPropertyType} from '@Components/color-fill';
import {useGetKeyFromTransitionOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromTransitionOfActiveItem';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface BlockAnimationColorOptionProps {
  onClickColorFill(): void;
  className?: string;
}

export function BlockAnimationColorOption({className = '', ...props}: BlockAnimationColorOptionProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const transitionType = useGetKeyFromTransitionOfActiveItem('type');
  const transitionColor = useGetKeyFromTransitionOfActiveItem('color');

  if (!activeItem) {
    throw new Error('Active item is undefined in use slideshow transition option');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected slideshow item instead got ${activeItem.gitype}`);
  }

  if (!activeItem.getSelectedSlide().isMediaSlide()) {
    return null;
  }

  if (transitionType === undefined || transitionType !== AnimationType.BLOCK || !transitionColor) {
    return null;
  }

  const onClickHandler = (): void => {
    props.onClickColorFill();
  };

  const getData = (): ColorFillStorage[] => {
    return [
      {
        id: 'text-color-object',
        fillType: ColorFillPropertyType.SOLID,
        color: getColorObjectArrayFromFillColor([transitionColor]),
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption className={className} id="block-transition-color-option" label={window.i18next.t('pmwjs_color')} data={getData()} onClick={onClickHandler} />
  );
}
